import React, { useState } from 'react';
import cs from 'classnames';
import styles from './index.module.less';
import V2FilterFooter from './V2FilterFooter';
import V2FormRangeTimePicker from '../../../Form/V2FormRangeTimePicker/V2FormRangeTimePicker';
import dayjs from 'dayjs';
import { useMethods } from '@lhb/hook';
import { isEqual, isNotEmpty, isNotEmptyAny } from '@lhb/func';
const V2FilterRangeTimePicker: React.FC<any> = ({
  name,
  headFilter,
  setHeadFilter,
  cacheHeadFilter,
  close,
  comType,
  extra,
  comProps,
}) => {
  const [targetValue, setTargetValue] = useState<any>(headFilter[name]);
  const methods = useMethods({
    confirm(newValue, force = false) {
      close();
      if (force) {
        setHeadFilter({
          ...headFilter,
          [name]: newValue
        });
      } else if (!isEqual(headFilter[name], newValue)) {
        if (!isNotEmpty(newValue) && !isNotEmpty(headFilter[name])) {
          return;
        }
        setHeadFilter({
          ...headFilter,
          [name]: newValue
        });
      }
    },
    handleSearch() {
      methods.confirm(targetValue);
    },
    clearFiltersAndClose() {
      if (isNotEmptyAny(targetValue?.value)) {
        methods.confirm(undefined, true);
      } else {
        methods.confirm(undefined);
      }
      setTargetValue(undefined);
    }
  });
  return (
    <div className={cs([styles.V2TableFilterCommon, styles.V2FilterRangePicker])}>
      <div>
        <V2FormRangeTimePicker
          noStyle
          config={{
            defaultValue: targetValue?.value?.map(item => dayjs(item, 'HH:mm')),
            format: 'HH:mm',
            onChange(value) {
              let newValue: any;
              if (Array.isArray(value) && value.filter(item => isNotEmpty(item)).length) {
                newValue = [dayjs(value[0] as any).format('HH:mm'), dayjs(value[1] as any).format('HH:mm')];
              }
              const res = {
                comType,
                value: newValue,
                extra
              };
              setTargetValue(res);
              cacheHeadFilter.current = {
                ...cacheHeadFilter.current,
                [name]: res
              };
            }
          }}
          {...comProps}
        />
      </div>
      <V2FilterFooter
        handleSearch={methods.handleSearch}
        clearFiltersAndClose={methods.clearFiltersAndClose}
      />
    </div>
  );
};

export default V2FilterRangeTimePicker;
